import { render, staticRenderFns } from "./AgencyProductsSettings.vue?vue&type=template&id=2b1ac460"
import script from "./AgencyProductsSettings.vue?vue&type=script&lang=ts"
export * from "./AgencyProductsSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports